import React from "react";
import { getLocalToken, getApplicationId } from "../../api/common";
import { Redirect, Route } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...rest }) => {
  // Add your own authentication on the below line.

  return (
    <Route
      {...rest}
      render={(props) =>
        getLocalToken() || getApplicationId() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
